import axios from "axios";

export default class LegislacaoMunicipalApi {
  constructor() {
    this.cancelTokens = {
      getLegislacoesByEnteFederativo: null,
      getAnosByEnteFederativo: null,
      getTiposByEnteFederativo: null,
      getAutoresByEnteFederativo: null,
      getCategoriasByEnteFederativo: null,
      getAtosInfralegaisByEnteFederativo: null,
      getMensagensVetoByEnteFederativo: null,
      getAtosAdministrativosByEnteFederativo: null,
      getTiposAtosAdministrativos: null,
      getAnosAtosAdministrativos: null,
      getTiposAtosInfralegais: null,
      getAnosAtosInfralegais: null,
      getTiposVeto: null,
      getAnosMensagensVeto: null,
      getOrgaosAtosInfralegais: null,
    };
  }

  isCancel(error) {
    return axios.isCancel(error);
  }

  async getEntesFederativos() {
    const url = `${process.env.VUE_APP_BASE_API_URL}/api/v1/pesquisa/legislacao_municipal`;
    const response = await axios.get(url);
    return response.data;
  }

  async getLegislacoesByEnteFederativo(enteFederativoId, params) {
    const url = `${process.env.VUE_APP_BASE_API_URL}/api/v1/pesquisa/legislacao_municipal/${enteFederativoId}/legislacoes`;

    const cancelTokenSource = axios.CancelToken.source();
    this.cancelTokens.getLegislacoesByEnteFederativo = cancelTokenSource;

    const response = await axios.get(url, {
      params,
      cancelToken: cancelTokenSource.token,
    });
    return response.data;
  }

  async getLegislacaoMunicipalById(enteFederativoId, legislacaoId) {
    // Usa o mesmo endpoint da API v2 que funciona para legislação estadual
    // pois as legislações municipais estão na mesma tabela
    const url = `${process.env.VUE_APP_BASE_API_URL}/api/v2/pesquisa/legislacoes/${legislacaoId}`;
    
    const response = await axios.get(url);
    return response.data;
  }

  async getAnosByEnteFederativo(enteFederativoId) {
    const url = `${process.env.VUE_APP_BASE_API_URL}/api/v1/pesquisa/legislacao_municipal/${enteFederativoId}/anos`;

    const cancelTokenSource = axios.CancelToken.source();
    this.cancelTokens.getAnosByEnteFederativo = cancelTokenSource;

    const response = await axios.get(url, {
      cancelToken: cancelTokenSource.token,
    });
    return response.data;
  }

  async getTiposByEnteFederativo(enteFederativoId) {
    const url = `${process.env.VUE_APP_BASE_API_URL}/api/v1/pesquisa/legislacao_municipal/${enteFederativoId}/tipos`;

    const cancelTokenSource = axios.CancelToken.source();
    this.cancelTokens.getTiposByEnteFederativo = cancelTokenSource;

    const response = await axios.get(url, {
      cancelToken: cancelTokenSource.token,
    });
    return response.data;
  }

  async getAutoresByEnteFederativo(enteFederativoId) {
    const url = `${process.env.VUE_APP_BASE_API_URL}/api/v1/pesquisa/legislacao_municipal/${enteFederativoId}/autores`;

    const cancelTokenSource = axios.CancelToken.source();
    this.cancelTokens.getAutoresByEnteFederativo = cancelTokenSource;

    const response = await axios.get(url, {
      cancelToken: cancelTokenSource.token,
    });
    return response.data;
  }

  async getCategoriasByEnteFederativo(enteFederativoId) {
    const url = `${process.env.VUE_APP_BASE_API_URL}/api/v1/pesquisa/legislacao_municipal/${enteFederativoId}/categorias`;

    const cancelTokenSource = axios.CancelToken.source();
    this.cancelTokens.getCategoriasByEnteFederativo = cancelTokenSource;

    const response = await axios.get(url, {
      cancelToken: cancelTokenSource.token,
    });
    return response.data;
  }

  async getAtosInfralegaisByEnteFederativo(enteFederativoId, params) {
    const url = `${process.env.VUE_APP_BASE_API_URL}/api/v1/pesquisa/legislacao_municipal/${enteFederativoId}/atos_infralegais`;

    const cancelTokenSource = axios.CancelToken.source();
    this.cancelTokens.getAtosInfralegaisByEnteFederativo = cancelTokenSource;

    const response = await axios.get(url, {
      params,
      cancelToken: cancelTokenSource.token,
    });
    return response.data;
  }

  async getMensagensVetoByEnteFederativo(enteFederativoId, params) {
    const url = `${process.env.VUE_APP_BASE_API_URL}/api/v1/pesquisa/legislacao_municipal/${enteFederativoId}/mensagens_veto`;

    const cancelTokenSource = axios.CancelToken.source();
    this.cancelTokens.getMensagensVetoByEnteFederativo = cancelTokenSource;

    const response = await axios.get(url, {
      params,
      cancelToken: cancelTokenSource.token,
    });
    return response.data;
  }

  async getAtosAdministrativosByEnteFederativo(enteFederativoId, params) {
    const url = `${process.env.VUE_APP_BASE_API_URL}/api/v1/pesquisa/legislacao_municipal/${enteFederativoId}/atos_administrativos`;

    const cancelTokenSource = axios.CancelToken.source();
    this.cancelTokens.getAtosAdministrativosByEnteFederativo = cancelTokenSource;

    const response = await axios.get(url, {
      params,
      cancelToken: cancelTokenSource.token,
    });
    return response.data;
  }

  async getTiposAtosAdministrativos(enteFederativoId) {
    const url = `${process.env.VUE_APP_BASE_API_URL}/api/v1/pesquisa/legislacao_municipal/${enteFederativoId}/tipos_atos_administrativos`;

    const cancelTokenSource = axios.CancelToken.source();
    this.cancelTokens.getTiposAtosAdministrativos = cancelTokenSource;

    const response = await axios.get(url, {
      cancelToken: cancelTokenSource.token,
    });
    return response.data;
  }

  async getAnosAtosAdministrativos(enteFederativoId) {
    const url = `${process.env.VUE_APP_BASE_API_URL}/api/v1/pesquisa/legislacao_municipal/${enteFederativoId}/anos_atos_administrativos`;

    const cancelTokenSource = axios.CancelToken.source();
    this.cancelTokens.getAnosAtosAdministrativos = cancelTokenSource;

    const response = await axios.get(url, {
      cancelToken: cancelTokenSource.token,
    });
    return response.data;
  }

  async getTiposAtosInfralegais(enteFederativoId) {
    const url = `${process.env.VUE_APP_BASE_API_URL}/api/v1/pesquisa/legislacao_municipal/${enteFederativoId}/tipos_atos_infralegais`;

    const cancelTokenSource = axios.CancelToken.source();
    this.cancelTokens.getTiposAtosInfralegais = cancelTokenSource;

    const response = await axios.get(url, {
      cancelToken: cancelTokenSource.token,
    });
    return response.data;
  }

  async getAnosAtosInfralegais(enteFederativoId) {
    const url = `${process.env.VUE_APP_BASE_API_URL}/api/v1/pesquisa/legislacao_municipal/${enteFederativoId}/anos_atos_infralegais`;

    const cancelTokenSource = axios.CancelToken.source();
    this.cancelTokens.getAnosAtosInfralegais = cancelTokenSource;

    const response = await axios.get(url, {
      cancelToken: cancelTokenSource.token,
    });
    return response.data;
  }

  async getTiposVeto(enteFederativoId) {
    const url = `${process.env.VUE_APP_BASE_API_URL}/api/v1/pesquisa/legislacao_municipal/${enteFederativoId}/tipos_veto`;

    const cancelTokenSource = axios.CancelToken.source();
    this.cancelTokens.getTiposVeto = cancelTokenSource;

    const response = await axios.get(url, {
      cancelToken: cancelTokenSource.token,
    });
    return response.data;
  }

  async getAnosMensagensVeto(enteFederativoId) {
    const url = `${process.env.VUE_APP_BASE_API_URL}/api/v1/pesquisa/legislacao_municipal/${enteFederativoId}/anos_mensagens_veto`;

    const cancelTokenSource = axios.CancelToken.source();
    this.cancelTokens.getAnosMensagensVeto = cancelTokenSource;

    const response = await axios.get(url, {
      cancelToken: cancelTokenSource.token,
    });
    return response.data;
  }

  async getOrgaosAtosInfralegais(enteFederativoId) {
    const url = `${process.env.VUE_APP_BASE_API_URL}/api/v1/pesquisa/legislacao_municipal/${enteFederativoId}/orgaos_atos_infralegais`;

    const cancelTokenSource = axios.CancelToken.source();
    this.cancelTokens.getOrgaosAtosInfralegais = cancelTokenSource;

    const response = await axios.get(url, {
      cancelToken: cancelTokenSource.token,
    });
    return response.data;
  }
}